import { FC } from 'react';
import { Button, Grid, GridProps, Typography, useTheme } from '@mui/material';
import { emptyState } from '@frontend/assets';
import { useTranslation } from 'react-i18next';

type Props = {
  title?: string;
  action?: {
    label: string;
    handler: () => void;
  };
} & GridProps;

export const EmptyState: FC<Props> = ({ action, title, ...rest }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Grid
      container
      sx={{
        margin: theme.spacing(10),
        backgroundColor: theme.palette.background.default,
      }}
      {...rest}
    >
      <Grid item xs={12} textAlign="center">
        <img width="140px" src={emptyState} />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Typography variant="body2">{title || t('common.tableList.empty')}</Typography>
      </Grid>
      {action && (
        <Grid item>
          <Button variant="outlined" color="secondary">
            {action.label}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
